import { memo } from "react";
import { ChatSendIcon } from "components/shared/svg-action-icons";

const ChatComposerSendControl = ({
  t,
  onSend,
  loading,
  hasPromptPermission,
  isRtl,
  buttonSize,
}) => {
  if (loading) {
    return (
      <div
        className={`${buttonSize} border-2 border-border-muted border-t-primary rounded-full animate-spin flex-shrink-0`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={onSend}
      disabled={!hasPromptPermission}
      title={t("chat.send")}
      className={`${buttonSize} rounded-[10px] flex items-center justify-center transition flex-shrink-0 bg-primary hover:bg-primary/90 disabled:bg-border-muted disabled:cursor-not-allowed`}
    >
      <ChatSendIcon className="w-4 h-4 text-white" mirrored={!isRtl} />
    </button>
  );
};

export default memo(ChatComposerSendControl);
